import { SPA_BASE_URL } from '@/utils/constants';

const resolveCategories = ({
  rawVal = [],
  categoryType,
  pageModels,
}: PropsWithCMSProps<CategoriesProps>) => {
  if (!rawVal || !categoryType) return [];
  const { taxonomy = {} } = pageModels || {};
  const regexp = new RegExp(`^${categoryType}/`, 'i');
  const rawCategories = rawVal.filter((val) => regexp.test(val));
  const categories = rawCategories.map((cat) => taxonomy[cat]);
  return categories.map((cat) => ({
    label: cat,
    href: `${SPA_BASE_URL}/search?${categoryType}=${cat}`,
  }));
};

export default resolveCategories;
